export enum AuthEnum {
  AUTH_COOKIE_KEY = "auth-session",
  USER_COOKIE_KEY = "user-data",
}
